<template>
    <div>
            <b-row>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('name')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.name) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('name_en')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.name_en) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('type')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.type) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('status')">
                        <b-input-group>
                            <div class="label-as-input">{{ getStatusText(form.status) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('max_class_average')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.max_class_average) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('min_score')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.min_score) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('max_score')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.max_score) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('min_number_of_participants')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.min_number_of_participants) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('min_relative_score')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.min_relative_score) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('min_final_score')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.min_final_score) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('min_semester_score')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.min_semester_score) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('t_score_multiplier')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.t_score_multiplier) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('t_score_effect')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.t_score_effect) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>

            </b-row>
    </div>
</template>

<script>
    //Service
    import EvaluationService from "@/services/EvaluationService";

    export default {
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                form: {
                    name: null,
                    name_en: null,
                    status: null,
                    max_class_average: null,
                    min_score: null,
                    max_score: null,
                    min_number_of_participants: null,
                    min_relative_score: null,
                    min_final_score: null,
                    min_semester_score: null,
                    t_score_multiplier: null,
                    t_score_effect: null,
                }
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                EvaluationService.get(id)
                           .then((response) => {
                               this.form = response.data.data;
                           })
                           .catch((error) => {
                               this.showErrors(error)
                           });
            }
        }
    }
</script>
